import script from "./transfer.vue?vue&type=script&setup=true&lang=js"
export * from "./transfer.vue?vue&type=script&setup=true&lang=js"

import "./transfer.vue?vue&type=style&index=0&id=74be6559&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/builds/jolly88-complex/frontend/affiliate-static-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74be6559"]])

export default __exports__